import ko from "knockout";
import dataModel from "data-model";
import * as _ from "lodash";
import { isEmpty, noop } from "global-functions";
import gridStateUtils from "jqx.grid-utils";
import gridState from "jqx.grid-state-component";
import userProfile from "user-profile";
import template from "./accessorial-restriction-page.html";
import { useDispatch } from "ko-data-store";
import { isLoading } from "../../../dataStore/actions/appUI";
import queryCache from "../../../utils/queryCache";
import toast from "geNotyf";
import { showconfirm } from "show-dialog-methods";

const apiDataAsync = (fetchUrl, fetchType, fetchParams) => {
  return new Promise((resolve, reject) => {
    dataModel
      .fetchAsync(fetchUrl, fetchType ?? "GET", fetchParams, true)
      .done((data) => resolve(data))
      .fail((error) => reject(error));
  });
};

const getAgencyDDT = () => {
  return apiDataAsync(`Lookup/Agencies`);
};

var chargeCodeDetailsViewModel = function (
  model,
  chargeCodeId,
  chargeCodeExternalId,
  chargeCodeDescription,
) {
  var self = this;
  self.canBulkAssign = ko.observable(model.canBulkAssign);
  self.canSingleAssign = ko.observable(model.canSingleAssign);
  self.chargeCodeId = ko.observable(chargeCodeId);
  self.chargeCodeExternalId = ko.observable(chargeCodeExternalId);
  self.chargeCodeDescription = ko.observable(chargeCodeDescription);

  self.leftSource = model.availableAgents;
  self.rightSource = model.assignedAgents;
  self.columns = [
    {
      text: "id",
      datafield: "id",
      hidden: true,
      columnType: "number",
      searchoptions: { sopt: ["eq", "ne", "cn"] },
    },
    {
      text: "Code",
      datafield: "externalId",
      columnType: "textbox",
      searchoptions: { sopt: ["eq", "ne", "cn"] },
    },
    {
      text: "Name",
      datafield: "name",
      columnType: "textbox",
      searchoptions: { sopt: ["eq", "ne", "cn"] },
    },
  ];
  self.fields = [
    { name: "id", type: "string" },
    { name: "externalId", type: "string" },
    { name: "name", type: "string" },
  ];
  self.refreshGrid = ko.observable(true);
  self.columnTransfer = function () {
    var availableIds = ko.utils.arrayMap(self.leftSource, function (item) {
      return item.id;
    });

    var assignedIds = ko.utils.arrayMap(self.rightSource, function (item) {
      return item.id;
    });

    var data = {
      selectedChargeCodeId: self.chargeCodeId(),
      available: availableIds,
      assigned: assignedIds,
    };
    dataModel
      .ajaxRequest(
        "AccessorialRestriction/TransferAgentChargeCodes/",
        "post",
        data,
      )
      .done(function (response, status, xhr) {
        var g = "blah";
      })
      .fail(function (error, msg, d) {
        var g = "blah";
      });
  };
};

var agencyDetailsViewModel = function (
  model,
  agencyId,
  agencyExternalId,
  agencyName,
) {
  var self = this;
  self.canBulkAssign = ko.observable(model.canBulkAssign);
  self.canSingleAssign = ko.observable(model.canSingleAssign);
  self.agencyId = ko.observable(agencyId);
  self.agencyExternalId = ko.observable(agencyExternalId);
  self.agencyName = ko.observable(agencyName);

  self.leftSource = model.availableChargeCodes;
  self.rightSource = model.assignedChargeCodes;
  self.columns = [
    {
      text: "id",
      datafield: "id",
      hidden: true,
      columnType: "number",
      searchoptions: { sopt: ["eq", "ne", "cn"] },
    },
    {
      text: "Code",
      datafield: "externalId",
      columnType: "textbox",
      searchoptions: { sopt: ["eq", "ne", "cn"] },
    },
    {
      text: "Name",
      datafield: "name",
      columnType: "textbox",
      searchoptions: { sopt: ["eq", "ne", "cn"] },
    },
  ];
  self.fields = [
    { name: "id", type: "string" },
    { name: "externalId", type: "string" },
    { name: "name", type: "string" },
  ];
  self.refreshGrid = ko.observable(true);
  self.columnTransfer = function () {
    var availableIds = ko.utils.arrayMap(self.leftSource, function (item) {
      return item.id;
    });

    var assignedIds = ko.utils.arrayMap(self.rightSource, function (item) {
      return item.id;
    });

    var data = {
      selectedAgencyId: self.agencyId(),
      available: availableIds,
      assigned: assignedIds,
    };
    dataModel
      .ajaxRequest(
        "AccessorialRestriction/TransferAgentChargeCodes/",
        "post",
        data,
      )
      .done(function (response, status, xhr) {
        var g = "blah";
      })
      .fail(function (error, msg, d) {
        var g = "blah";
      });
  };
};

class ExternalMappingsViewModel {
  chargeCodesCache = new queryCache(1000 * 10); // 1 min
  externalCodesCache = new queryCache(1000 * 10); // 1 min
  externalCodes = [];
  currentMappings = [];
  sourceMappings = [];
  dispatch = useDispatch();
  isOpen = false;

  constructor() {}

  // Wait until modal opens fully or jqx throws an error.
  onOpen = async () => {
    if (this.isOpen) return;
    this.isOpen = true;

    this.dispatch(isLoading(true));

    await this.getExternalCodes();
    this.loadThirdPartyDDL();
    this.loadThirdPartyCodesDDL();
    await this.loadMappingsGrid();
  };

  getExternalCodes = async (agencyId) => {
    try {
      const result = await this.externalCodesCache.fetch(
        "external_codes_ddt",
        async () =>
          await apiDataAsync(
            `AccessorialRestriction/GetTPChargeCodesDDT?agencyId=${agencyId}`,
            "GET",
          ),
      );

      this.currentMappings = result ?? [];
      this.externalCodes = result.map((x) => x.thirdPartyCode);
    } catch (err) {
      //
    }
  };

  loadThirdPartyDDL = () => {
    $("#thirdPartyDDL").jqxDropDownList({
      source: [{ label: "Mastery", value: 3 }],
      displayMember: "label",
      valueMember: "value",
      height: 25,
      dropDownHeight: 200,
      selectedIndex: 0,
      placeHolder: "Select External System",
    });
  };

  loadThirdPartyCodesDDL = () => {
    $("#thirdPartyCodesDDL").jqxDropDownList({
      source: this.externalCodes ?? [],
      height: 25,
      dropDownHeight: 200,
      dropDownWidth: 200,
      filterable: true,
      filterPlaceHolder: "Search External Code",
      placeHolder: "Select External Code",
    });

    $("#thirdPartyCodesDDL").on("change", this.handleThirdPartyCodeChange);
  };

  loadMappingsGridSource = () => {
    const source = {
      localdata: this.sourceMappings ?? [],
      datatype: "array",
      datafields: [
        { name: "chargeCode", type: "string" },
        { name: "agencies", type: "array" },
      ],
    };

    const adapter = new $.jqx.dataAdapter(source);
    $("#thirdPartyMappingsGrid").jqxGrid({ source: adapter });
  };

  handleAddRow = () => {
    this.sourceMappings.push({
      chargeCode: "_NEW_",
      agencies: [],
      isNew: true,
    });
  };

  loadMappingsGrid = async () => {
    const chargeCodesDDT = await this.chargeCodesCache.fetch(
      "charge_codes_ddt",
      async () => {
        return new Promise(async (resolve, reject) => {
          dataModel
            .ajaxRequest(
              "AccessorialRestriction/GetChargeCodesDDT",
              "GET",
              null,
              true,
            )
            .done(resolve)
            .fail((err) => reject(`Unable to get charge codes DDT`));
        });
      },
    );

    $("#thirdPartyMappingsGrid").jqxGrid({
      width: "100%",
      source: [],
      height: 300,
      sortable: false,
      pageable: false,
      virtualmode: false,
      compact: true,
      filterable: false,
      showfilterrow: false,
      autoheight: false,
      columnsresize: false,
      columnsreorder: false,
      columnsmenu: false,
      enablehover: false,
      //rowsheight: 32,
      columns: [
        {
          text: "Charge Code",
          dataField: "chargeCode",
          width: 200,
          createwidget: (row, column, value, cellElement) => {
            const currentItems =
              this.sourceMappings.map((x) => x.chargeCode) ?? [];
            const filteredItems = chargeCodesDDT.filter(
              (x) =>
                currentItems.indexOf(x.externalID) == -1 ||
                x.externalID == value,
            );

            $(cellElement).jqxDropDownList({
              source: filteredItems,
              height: 25,
              dropDownHeight: 200,
              dropDownWidth: 250,
              displayMember: "externalID",
              valueMember: "externalID",
              filterable: true,
              filterPlaceHolder: "Search Charge Code",
              placeHolder: "Select Charge Code",
              renderer: (index, label, value) => {
                const item = chargeCodesDDT[index];
                return `${item.externalID} - ${item.description}`;
              },
              selectionRenderer: (htmlItem) => {
                const $htmlItem = $(htmlItem);
                const index =
                  $(cellElement).jqxDropDownList("getSelectedIndex");

                if (index > -1) {
                  const item = chargeCodesDDT[index];
                  const text = `${item.externalID} - ${item.description}`;
                  $htmlItem.html(text);
                }

                $htmlItem.parent().css({ padding: "3px" });

                return $htmlItem[0].outerHTML;
              },
            });

            if (value && chargeCodesDDT.length > 0) {
              $(cellElement).jqxDropDownList("selectItem", value);
            }

            $(cellElement).on("change", (event) => {
              const args = event.args ?? {};
              const item = args.item;

              if (item) {
                const newValue = item.value;
                const match = this.sourceMappings.find(
                  (x) => x.chargeCode == value,
                );

                if (match && newValue != value) {
                  match.chargeCode = newValue;
                  this.loadMappingsGridSource();
                }
              }
            });
          },
          initwidget: (row, column, value, cellElement) => {}, // need to have this even if not used when using createwidget
        },
        {
          text: "Agencies",
          dataField: "agencies",
          filterable: false,
          sortable: false,
          createwidget: (row, column, value, cellElement) => {
            const datarow = row.bounddata ?? {};
            const allAgencies = userProfile.userAgencies() ?? [];
            const mapped = allAgencies
              .filter((x) => x.isActive)
              .map((x) => x.externalID);

            $(cellElement).jqxDropDownList({
              source: mapped,
              height: 25,
              dropDownHeight: 200,
              //dropDownWidth: 200,
              filterable: true,
              checkboxes: true,
              filterPlaceHolder: "Search Agency",
              placeHolder: "Select Agency",
            });

            if (value && mapped.length > 0) {
              value.forEach((agency) => {
                $(cellElement).jqxDropDownList("checkItem", agency);
              });
            }

            $(cellElement).on("close", (event) => {
              const checkedItems =
                $(cellElement).jqxDropDownList("getCheckedItems");
              const match = this.sourceMappings.find(
                (x) => x.chargeCode == datarow.chargeCode,
              );

              if (match) {
                match.agencies = checkedItems.map((x) => x.value);
                this.loadMappingsGridSource();
              }
            });
          },
          initwidget: (row, column, value, cellElement) => {}, // need to have this even if not used when using createwidget
        },
        {
          text: "",
          width: 100,
          sortable: false,
          filterable: false,
          createwidget: (row, column, value, cellElement) => {
            const datarow = this.sourceMappings.find(
              (x) => x.chargeCode == row.bounddata?.chargeCode,
            );
            const $container = $(cellElement).css({ marginTop: 0 });
            const isDisabled =
              datarow.chargeCode == "_NEW_" || !datarow.agencies.length;

            const $btn = $("<button>", {
              class: "btn btn-ge-grey",
              id: "btnAddMapping",
              text: !datarow.isNew ? "Remove" : "Add",
              style: `padding: 1px 8px; font-size: 12px; margin-left: 3px; border: 1px solid #ccc; width: ${
                cellElement.offsetWidth - 5
              }px; height: ${cellElement.offsetHeight}px;`,
              disabled: isDisabled,
              title: !datarow.isNew
                ? "Remove Mapped Row"
                : isDisabled
                  ? "Select charge code and at least 1 agency."
                  : "Add Mapped Row",
            }).appendTo($container);

            $btn.on("click", (event) => {
              if ($btn.text() == "Remove") {
                this.sourceMappings = this.sourceMappings.filter(
                  (x) => x.chargeCode != datarow.chargeCode,
                );
                this.loadMappingsGridSource();
              }

              if (
                datarow.isNew &&
                datarow.chargeCode != "_NEW_" &&
                datarow.agencies.length > 0
              ) {
                datarow.isNew = false;
                this.handleAddRow();
                this.loadMappingsGridSource();
              }
            });
          },
          initwidget: (row, column, value, cellElement) => {},
        },
      ],
      ready: () => {
        this.dispatch(isLoading(false));
      },
    });
  };

  handleThirdPartyCodeChange = (event) => {
    const args = event.args ?? {};
    const item = args.item;

    this.sourceIndex = this.currentMappings.findIndex(
      (x) => x.thirdPartyCode == item.value,
    );
    this.sourceMappings =
      this.currentMappings[this.sourceIndex]?.assignments ?? [];

    // Add a new empty editable row.
    this.handleAddRow();
    this.loadMappingsGridSource();
  };

  dispose = () => {
    $("#thirdPartyCodesDDL").off("change", this.handleThirdPartyCodeChange);
  };
}

class AgencyExternalMappingsViewModel {
  selectedAgency = ko.observable();
  newMappingRow = ko
    .observable({
      chargeCode: "_NEW_",
      thirdPartyCode: "_NEW_",
      description: "_NEW_",
    })
    .extend({ notify: "always" });
  helpText = ko.observable("");
  addUpdateBtnDisabled = ko.pureComputed(() => {
    return (
      this.newMappingRow().chargeCode == "_NEW_" ||
      this.newMappingRow().thirdPartyCode == "_NEW_"
    );
  });
  externalCodesCache = new queryCache(1000 * 10); // 1 min
  currentMappings = [];
  sourceMappings = [];
  dispatch = useDispatch();
  isOpen = false;
  onChange = noop;
  agencyId = null;

  constructor({ agencyId, agency, onChange }) {
    this.agencyId = agencyId;
    this.selectedAgency(agencyId);
    this.onChange = onChange ?? noop;
  }

  // Wait until modal opens fully or jqx throws an error.
  onOpen = async () => {
    if (this.isOpen) return;
    this.isOpen = true;

    this.loadThirdPartyDDL();
    await this.loadAgencyDDL();
    await this.loadMappingsGrid();
  };

  getAgencyMappings = async () => {
    try {
      this.dispatch(isLoading(true));
      const result = await apiDataAsync(
        "AccessorialRestriction/GetTPAgencyChargeCodeMappings",
        "GET",
        { agencyId: this.agencyId },
      );
      this.currentMappings = result ?? [];
    } catch (err) {
      this.dispatch(isLoading(false));
    } finally {
      this.dispatch(isLoading(false));
    }
  };

  loadAgencyDDL = async () => {
    const agencies = await apiDataAsync(`Lookup/Agencies`);
    const source = agencies.map((x) => ({
      label: x.code,
      value: x.id,
    }));

    $("#agencyDDL").jqxDropDownList({
      source: source ?? [],
      displayMember: "label",
      valueMember: "value",
      height: 25,
      dropDownHeight: 200,
      dropDownWidth: 200,
      filterable: true,
      filterPlaceHolder: "Search Agency",
      placeHolder: "Select Agency",
    });

    $("#agencyDDL").on("change", this.handleAgencyChange);

    if (this.selectedAgency()) {
      $("#agencyDDL").jqxDropDownList("selectItem", this.selectedAgency());
    }
  };

  loadThirdPartyDDL = () => {
    $("#agencyThirdPartyDDL").jqxDropDownList({
      source: ["Mastery"],
      height: 25,
      dropDownHeight: 200,
      selectedIndex: 0,
      placeHolder: "Select External System",
    });
  };

  loadThirdPartyCodesDDL = async () => {
    const thirdPartyDDT = await this.externalCodesCache.fetch(
      "external_codes_ddt" + this.agencyId,
      async () =>
        await apiDataAsync(
          `AccessorialRestriction/GetTPChargeCodesDDT?agencyId=${this.agencyId}`,
          "GET",
        ),
    );

    $("#agencyThirdPartyCodeDDL").jqxDropDownList({
      source: thirdPartyDDT ?? [],
      height: 25,
      displayMember: "description",
      valueMember: "thirdPartyCode",
      dropDownHeight: 200,
      dropDownWidth: 250,
      filterable: true,
      filterPlaceHolder: "Search External Code",
      placeHolder: "Select External Code",
      renderer: function (index, label, value) {
        if (label == value) {
          return label;
        }

        return `${value} - ${label}`;
      },
    });

    $("#agencyThirdPartyCodeDDL").on("change", (event) => {
      const args = event.args ?? {};
      const item = args.item;

      if (item) {
        this.newMappingRow({
          ...this.newMappingRow(),
          thirdPartyCode: item.value,
          description: item.label,
        });

        if (this.sourceMappings.some((x) => x.thirdPartyCode == item.value)) {
          this.helpText(
            "Note: Any saved changes will overwrite the existing third party mapping.",
          );
        }
      }
    });
  };

  resetWidgets = async () => {
    this.newMappingRow({
      chargeCode: "_NEW_",
      thirdPartyCode: "_NEW_",
      description: "_NEW_",
    });
    this.helpText("");

    await this.loadThirdPartyCodesDDL();
    await this.loadAgencyChargeCodesDDL();

    $("#agencyChargeCodeDDL").jqxDropDownList("clearSelection");
    $("#agencyThirdPartyCodeDDL").jqxDropDownList("clearSelection");
  };

  loadAgencyChargeCodesDDL = async () => {
    const chargeCodesDDT = await apiDataAsync(
      "AccessorialRestriction/GetChargeCodesDDT",
      "GET",
      { agencyId: this.agencyId },
    );

    $("#agencyChargeCodeDDL").jqxDropDownList({
      source: chargeCodesDDT ?? [],
      height: 25,
      displayMember: "externalID",
      valueMember: "externalID",
      dropDownHeight: 200,
      dropDownWidth: 250,
      filterable: true,
      filterPlaceHolder: "Search Charge Code",
      placeHolder: "Select Charge Code",
      renderer: function (index, label, value) {
        var datarecord = chargeCodesDDT[index];
        return `${datarecord.externalID} - ${datarecord.description}`;
      },
    });

    $("#agencyChargeCodeDDL").on("change", (event) => {
      const args = event.args ?? {};
      const item = args.item;

      if (item) {
        this.newMappingRow({ ...this.newMappingRow(), chargeCode: item.value });
      }
    });
  };

  loadMappingsGridSource = async () => {
    await this.getAgencyMappings();
    this.sourceIndex =
      this.currentMappings.findIndex(
        (x) => x.agencyId == this.selectedAgency(),
      ) ?? -1;
    this.sourceMappings =
      this.currentMappings[this.sourceIndex]?.assignments ?? [];

    const source = {
      localdata: this.sourceMappings ?? [],
      datatype: "array",
      datafields: [
        { name: "thirdPartyCode", type: "string" },
        { name: "chargeCode", type: "string" },
      ],
    };

    const adapter = new $.jqx.dataAdapter(source);
    $("#agencyThirdPartyMappingsGrid").jqxGrid({ source: adapter });
  };

  loadMappingsGrid = async () => {
    $("#agencyThirdPartyMappingsGrid").jqxGrid({
      width: "100%",
      source: [],
      height: 300,
      sortable: true,
      pageable: false,
      virtualmode: false,
      compact: true,
      filterable: true,
      showfilterrow: true,
      autoheight: false,
      columnsresize: false,
      columnsreorder: false,
      columnsmenu: false,
      enablehover: false,
      //rowsheight: 32,
      columns: [
        {
          text: "Third Party Code",
          dataField: "thirdPartyCode",
        },
        {
          text: "Charge Code",
          dataField: "chargeCode",
          width: 200,
        },
        {
          text: "",
          width: 100,
          sortable: false,
          filterable: false,
          createwidget: (row, column, value, cellElement) => {
            const datarow =
              this.sourceMappings.find(
                (x) => x.thirdPartyCode == row.bounddata?.thirdPartyCode,
              ) ?? {};
            const $container = $(cellElement).css({ marginTop: 0 });
            const isDisabled = datarow.thirdPartyCode == "_NEW_";

            const $btn = $("<button>", {
              class: "btn btn-ge-grey",
              id: "btnAddMapping",
              text: "Remove",
              style: `padding: 1px 8px; font-size: 12px; margin-left: 3px; border: 1px solid #ccc; width: ${
                cellElement.offsetWidth - 5
              }px; height: ${cellElement.offsetHeight}px;`,
              disabled: isDisabled,
            }).appendTo($container);

            $btn.on("click", async (event) => {
              if ($btn.text() == "Remove") {
                await this.handleDeleteMapping(datarow.thirdPartyCode);
              }
            });
          },
          initwidget: (row, column, value, cellElement) => {},
        },
      ],
      ready: () => {
        this.dispatch(isLoading(false));
      },
    });
  };

  handleAgencyChange = async (event) => {
    const args = event.args ?? {};
    const item = args.item;

    this.selectedAgency(item.value);
    await this.resetWidgets();
    await this.loadMappingsGridSource();
  };

  handleDeleteMapping = async (thirdPartyCode) => {
    try {
      this.dispatch(isLoading(true));

      await apiDataAsync(
        `AccessorialRestriction/DeleteAgencyTPChargeCode/${this.agencyId}/${thirdPartyCode}`,
        "DELETE",
      );
      this.loadMappingsGridSource();

      toast.open({ type: "info", message: "Mapping Removed." });

      if (this.onChange) {
        this.onChange();
      }
    } catch (err) {
      toast.open({
        type: "error",
        message: err && err.message ? err.message : "Error removing mapping.",
      });
    } finally {
      this.dispatch(isLoading(false));
    }
  };

  handleSaveMapping = async () => {
    try {
      const tpItem = $("#agencyThirdPartyDDL").jqxDropDownList(
        "getSelectedItem",
      );
      const payload = {
        thirdParty: tpItem.value,
        agencyId: this.agencyId,
        agency: this.selectedAgency(),
        ...this.newMappingRow(),
      };

      const matchingRow = this.sourceMappings.find(
        (x) => x.thirdPartyCode == payload.thirdPartyCode,
      );
      if (matchingRow && matchingRow.chargeCode != payload.chargeCode) {
        const answer = await showconfirm(
          `<span style="font-size: 12px">Third party code '${matchingRow.thirdPartyCode}' is already mapped to charge code '${matchingRow.chargeCode}'.<br/><br/> Do you want to overwrite the mapping?</span>`,
        );

        if (!answer) {
          this.resetWidgets();
          return;
        }
      }

      this.dispatch(isLoading(true));
      await apiDataAsync(
        "AccessorialRestriction/UpsertAgencyTPChargeCode",
        "POST",
        payload,
      );
      await this.resetWidgets();
      this.loadMappingsGridSource();

      toast.open({ type: "info", message: "Mapping Saved." });

      if (this.onChange) {
        this.onChange();
      }
    } catch (err) {
      toast.open({
        type: "error",
        message: err && err.message ? err.message : "Error saving mapping.",
      });
    } finally {
      this.dispatch(isLoading(false));
    }
  };

  dispose = () => {
    $("#agencyDDL").off("change", this.handleAgencyChange);
  };
}

var loadChargeCodes = function (chargeCodeDetailsWindow, userSavedFilters) {
  var self = {}; //These 2 functions aren't objects so there's no 'this'.
  self.chargeCodeDetailsWindow = chargeCodeDetailsWindow;
  var updateGrid = false;
  var ratingUpdated = false;
  self.chargeCodeGridState = userSavedFilters || {};

  var source = {
    url: "AccessorialRestriction/GetChargeCodesForGrid",
    datatype: "json",
    sortcolumn: "chargeCode",
    sortdirection: "asc",
    data: {
      agencyId: userProfile.currentAgencyId(),
    },
    filter: function (items) {
      // update the grid and send a request to the server.
      $("#jqxChargeCodes").jqxGrid("updatebounddata", "filter");
    },
    sort: function (column, sortOrder) {
      $("#jqxChargeCodes").jqxGrid("updatebounddata", "sort");
    },
    beforeprocessing: function (data) {
      source.totalrecords = data.totalrecords;
      // Convert our codes into friendly display names
      setWhoToPayDisplayName(data);

      data.records = (data.records || []).map((x) => {
        x.embed = x.embed == "Y" ? true : false;
        return x;
      });
    },
    formatdata: function (data) {
      var columns = new Array();

      data = {
        chargeCode: data.chargeCode,
        description: data.description,
        agencyPayPercent: data.agencyPayPercent,
        ooPayPercent: data.ooPayPercent,
        ediChargeCode: data.ediChargeCode,
        embed: data.embed,
        whoToPay: data.whoToPay,
        agencyId: userProfile.currentAgencyId(),
        recordstartindex: data.recordstartindex,
        recordendindex: data.recordendindex,
        pagesize: data.pagesize,
        pagenum: data.pagenum,
        sortdatafield: data.sortdatafield,
        sortorder: data.sortorder,
        columns: columns,
      };

      var filterinfo = $("#jqxChargeCodes").jqxGrid("getfilterinformation");
      for (let i = 0; i < filterinfo.length; i++) {
        var filterName = filterinfo[i].datafield;

        var filters = filterinfo[i].filter.getfilters();

        for (var j = 0; j < filters.length; j++) {
          if (filters.length > 1) {
            data[filterName][j] = filters[j].id
              ? filters[j].id
              : filters[j].value;
          } else {
            data[filterName] = filters[j].id ? filters[j].id : filters[j].value;
          }
        }
      }

      Object.keys(data).forEach((key) => {
        if (data[key] === "Please Choose:") data[key] = undefined;
      });

      data.embed = data.embed == null ? null : data.embed ? "Y" : "N";

      return data;
    },
    datafields: [
      { name: "id", type: "int" },
      { name: "chargeCode", type: "string" },
      { name: "description", type: "string" },
      { name: "agencyPayPercent", type: "float" },
      { name: "ooPayPercent", type: "float" },
      { name: "ediChargeCode", type: "string" },
      { name: "agentPayMethod", type: "string" },
      { name: "ownerOperatorPayMethod", type: "string" },
      { name: "whoToPay", type: "string" },
      { name: "embed", type: "boolean" },
      { name: "rating", type: "int" },
    ],
  };

  var dataAdapter = dataModel.getDataAdapter(source);

  $("#jqxChargeCodes").jqxGrid({
    width: "100%",
    source: dataAdapter,
    selectionmode: "single",
    height: 300,
    sortable: true,
    pageable: true,
    filterable: true,
    showfilterrow: true,
    virtualmode: true,
    autoheight: false,
    columnsresize: true,
    columnsreorder: true,
    columnsmenu: false,
    showtoolbar: true,
    compact: true,
    pagesize: 10,
    rendertoolbar: (toolbar) => {
      let vm1 = new gridState.viewModel();
      vm1.initializeDefaultToolbar(toolbar);
    },
    rendergridrows: function (obj) {
      return obj.data;
    },
    ready: function () {
      this.detailsVisibility = new Array();
      gridStateUtils.applyGridState("jqxChargeCodes", self.chargeCodeGridState);
    },
    columns: [
      {
        text: "",
        width: 150,
        columnType: "button",
        sortable: false,
        pinned: true,
        filterable: false,
        buttonclick: function (row) {
          var datarow = $("#jqxChargeCodes").jqxGrid("getrowdata", row);
          dataModel
            .ajaxRequest(
              "AccessorialRestriction/GetChargeCodeDetails/" + datarow.id,
              "GET",
            )
            .done(function (data, status, xhr) {
              self.chargeCodeDetailsWindow(
                new chargeCodeDetailsViewModel(
                  data,
                  datarow.id,
                  datarow.chargeCode,
                  datarow.description,
                ),
              );
            })
            .fail(function (error, msg, d) {});
        },
        cellsrenderer: function () {
          return "Assigned Agents";
        },
      },
      { text: "Charge Code", dataField: "chargeCode", width: 120 },
      { text: "Description", dataField: "description" },
      { text: "Agency Pay Percent", dataField: "agencyPayPercent", width: 180 },
      { text: "O/O Pay Percent", dataField: "ooPayPercent", width: 120 },
      { text: "EDI Charge Code", dataField: "ediChargeCode", width: 150 },
      {
        text: "Agent Pay Method",
        dataField: "agentPayMethod",
        width: 150,
        filtertype: "list",
        filteritems: [
          { value: "P", label: "Percentage" },
          { value: "F", label: "Flat" },
          { value: "R", label: "Pro-Rate" },
        ],
      },
      {
        text: "Owner Operator Pay Method",
        dataField: "ownerOperatorPayMethod",
        width: 150,
        filtertype: "list",
        filteritems: [
          { value: "P", label: "Percentage" },
          { value: "F", label: "Flat" },
          { value: "A", label: "All" },
        ],
      },
      {
        text: "Who to Pay",
        dataField: "whoToPay",
        width: 150,
        filtertype: "list",
        filteritems: [
          { value: "R", label: "Pro-rate" },
          { value: "N", label: "No Driver" },
          { value: "P", label: "Pickup Driver" },
          { value: "D", label: "Delivery  Driver" },
          { value: "O", label: "Other  Driver" },
        ],
      },
      {
        text: "Embed",
        dataField: "embed",
        width: 70,
        filtertype: "bool",
        columntype: "checkbox",
        editable: false,
      },
      {
        text: "Rating",
        dataField: "rating",
        width: 140,
        filtertype: "list",
        filteritems: [
          {
            value: 5,
            label: "5",
            html: "<img src='../Content/Images/5star.png' />",
          },
          {
            value: 4,
            label: "4",
            html: "<img src='../Content/Images/4star.png' />",
          },
          {
            value: 3,
            label: "3",
            html: "<img src='../Content/Images/3star.png' />",
          },
          {
            value: 2,
            label: "2",
            html: "<img src='../Content/Images/2star.png' />",
          },
          {
            value: 1,
            label: "1",
            html: "<img src='../Content/Images/1star.png' />",
          },
        ],
        cellsrenderer: function (
          row,
          columnfield,
          value,
          defaultHTML,
          column,
          rowData,
        ) {
          if (defaultHTML != null) {
            let pk = $("#jqxChargeCodes").jqxGrid("getcellvalue", row, "id");
            var fieldset = $("<fieldset>");
            fieldset.addClass("star-rating");
            fieldset.attr("id", "jqxRating_" + pk);

            for (var i = 5; i > 0; i--) {
              var id = "jqxRating_" + pk + i;
              var input = $("<input>");
              input.attr({
                type: "radio",
                id: "star" + i,
                name: "rating",
                value: i,
              });
              input.appendTo(fieldset);
              var label = $("<label>").text(i);
              if (value == i) {
                label.attr({ for: "star" + i });
              }
              label.insertAfter(input);
              //set the div as click target
              $(document)
                .off("click", "#jqxRating_" + pk)
                .on("click", "#jqxRating_" + pk, function (event) {
                  var newRating;
                  var previousRating;
                  //added tagName condition because click event firing for both the label and input of each star element
                  //iterate through each of the 5 star-ratings for this target div
                  if (event.target.tagName == "LABEL") {
                    //get the value of the star-rating the user selected (1, 2, 3, 4, 5)
                    newRating = event.target.previousSibling.value;
                    $(event.target.parentElement.children).each(function (i) {
                      if (this.tagName == "LABEL") {
                        //if the label has a 'for' attribute, this will be the previous rating
                        if (this.attributes.length > 0) {
                          if (this.attributes.for.value != null) {
                            previousRating =
                              this.attributes.for.value.slice(-1);
                          }
                          //if the user is selecting a new rating, remove the current 'for' attribute
                          //this is how the css determines how many stars to highlight
                          //attribute 'for: star4' will show four stars highlighted, etc.
                          if (previousRating != newRating) {
                            $(this).removeAttr("for");
                          }
                        }
                      }
                    });
                    if (previousRating != newRating) {
                      //get the Id of the input for the label selected by the user (star1, star2, star3, star4, star5)
                      var inputId =
                        event.target.previousSibling.attributes.getNamedItem(
                          "id",
                        ).value;
                      //set the 'for' attribute for the label the user selected to the Id above.
                      //if the user selected a 'star4', then set the corresponding label to 'for: star4'
                      //this impacts the css applied
                      $(event.target).attr("for", inputId);
                      //get the id for the selected carrier by getting the parent id of the selected star input
                      var id = event.target.parentElement.id.replace(
                        "jqxRating_",
                        "",
                      );
                      var params = {
                        objectId: id,
                        value: newRating,
                        agencyId: userProfile.currentAgencyId(),
                        favTable: 5,
                      };
                      dataModel
                        .ajaxRequest("Rating", "post", params)
                        .done(function (data, textStatus, jqXHR) {
                          updateGrid = true;
                          ratingUpdated = true;
                          $("#jqxChargeCodes").jqxGrid(
                            "updatebounddata",
                            "data",
                          );
                        })
                        .fail(function (error, msg, d) {});
                    }
                  }
                });
            }
            return fieldset[0].outerHTML;
          }
          return defaultHTML;
        },
        createfilterwidget: function (column, columnElement, widget) {
          widget.jqxDropDownList({
            dropDownWidth: 140,
            renderer: function (index, label, value) {
              if (value != "") {
                return "<img src='../Content/Images/" + value + "star.png' />";
              } else {
                return "Any";
              }
            },
          });
        },
      },
    ],
  });

  function setWhoToPayDisplayName(data) {
    if (data == null || data.records == null || data.records.length == 0)
      return false;

    var _whoToPayDisplayName = "";
    for (var i = 0; i < data.records.length; i++) {
      if (data.records[i].whoToPay == null) continue;

      switch (data.records[i].whoToPay) {
        case "R":
          _whoToPayDisplayName = "Pro-rate";
          break;
        case "N":
          _whoToPayDisplayName = "No Driver";
          break;
        case "P":
          _whoToPayDisplayName = "Pickup Driver";
          break;
        case "D":
          _whoToPayDisplayName = "Delivery Driver";
          break;
        case "O":
          _whoToPayDisplayName = "Other Driver";
          break;
        default:
          _whoToPayDisplayName = "";
          break;
      }

      data.records[i].whoToPay = _whoToPayDisplayName;
    }
  }

  var _payMethodCodes = [
    { key: "P", value: "Percent" },
    { key: "F", value: "Flat" },
    { key: "R", value: "Pro-rate" },
  ];

  function setPayMethodDisplayName(data) {
    if (data == null || data.records == null || data.records.length == 0)
      return false;

    for (var i = 0; i < data.records.length; i++) {
      var _agentPayMethodKeyValuePair =
        _payMethodCodes["key"][data.records[i].agentPayMethod];
      var _ooPayMethodKeyValuePair =
        _payMethodCodes["key"][data.records[i].ownerOperatorPayMethod];

      data.records[i].agentPayMethod = _agentPayMethodKeyValuePair
        ? _agentPayMethodKeyValuePair.value
        : "";
      data.records[i].ownerOperatorPayMethod = _ooPayMethodKeyValuePair
        ? _ooPayMethodKeyValuePair.value
        : "";
    }
  }
};

var loadAgencies = function (
  agencyDetailsWindow,
  agencyExternalMappingsWindow,
  userSavedFilters,
) {
  var self = {};
  self.agencyDetailsWindow = agencyDetailsWindow;
  self.agencyGridState = userSavedFilters || {};

  var source = {
    url: "AccessorialRestriction/GetAgenciesForGrid",
    datatype: "json",
    sortcolumn: "externalId",
    sortdirection: "asc",
    data: {
      agencyId: userProfile.currentAgencyId(),
    },
    filter: function (items) {
      // update the grid and send a request to the server.
      $("#jqxAgencies").jqxGrid("updatebounddata", "filter");
    },
    sort: function (column, sortOrder) {
      $("#jqxAgencies").jqxGrid("updatebounddata", "sort");
    },
    beforeprocessing: function (data) {
      source.totalrecords = data.totalrecords;
    },

    formatdata: function (data) {
      var columns = new Array();

      data = {
        externalId: data.externalId,
        name: data.name,
        agencyPercent: data.agencyPercent,
        agencyId: userProfile.currentAgencyId(),
        recordstartindex: data.recordstartindex,
        recordendindex: data.recordendindex,
        pagesize: data.pagesize,
        pagenum: data.pagenum,
        sortdatafield: data.sortdatafield,
        sortorder: data.sortorder,
        columns: columns,
        active: true,
      };

      var filterinfo = $("#jqxAgencies").jqxGrid("getfilterinformation");
      for (let i = 0; i < filterinfo.length; i++) {
        var filterName = filterinfo[i].datafield;

        var filters = filterinfo[i].filter.getfilters();

        for (var j = 0; j < filters.length; j++) {
          if (filters.length > 1) {
            data[filterName][j] = filters[j].value;
          } else {
            data[filterName] = filters[j].value;
          }
        }
      }
      return data;
    },
    datafields: [
      { name: "id", type: "int" },
      { name: "externalId", type: "string" },
      { name: "name", type: "string" },
      { name: "agencyPercent", type: "float" },
    ],
  };

  var dataAdapter = dataModel.getDataAdapter(source);

  $("#jqxAgencies").jqxGrid({
    width: "100%",
    source: dataAdapter,
    selectionmode: "single",
    sortable: true,
    pageable: true,
    virtualmode: true,
    filterable: true,
    showfilterrow: true,
    autoheight: false,
    height: 300,
    columnsresize: false,
    columnsreorder: false,
    columnsmenu: false,
    compact: true,
    pagesize: 10,
    showtoolbar: true,
    rendertoolbar: (toolbar) => {
      let vm1 = new gridState.viewModel();

      const $toolbar = $(toolbar);
      const $container = $("<div>");
      $toolbar.append($container);
      vm1.initializeDefaultToolbar($container);

      // const $button = $("<button>", {
      //     class: "btn btn-ge-grey",
      //     id: "btnAddMapping",
      //     text: "Add External Mapping",
      //     style: "padding: 3px 8px; font-size: 12px; margin-top: 2px; border: 1px solid #ccc;",
      // }).appendTo($container);

      // $button.on("click", function () {
      //     agencyExternalMappingsWindow(new AgencyExternalMappingsViewModel());
      // });
    },
    rendergridrows: function (obj) {
      return obj.data;
    },
    ready: function () {
      this.detailsVisibility = new Array();
      gridStateUtils.applyGridState("jqxAgencies", self.agencyGridState);
    },
    columns: [
      {
        text: "",
        width: 150,
        columnType: "button",
        sortable: false,
        pinned: true,
        filterable: false,
        buttonclick: function (row) {
          var datarow = $("#jqxAgencies").jqxGrid("getrowdata", row);
          dataModel
            .ajaxRequest(
              "AccessorialRestriction/GetAgencyDetails/" + datarow.id,
              "GET",
            )
            .done(function (data, status, xhr) {
              self.agencyDetailsWindow(
                new agencyDetailsViewModel(
                  data,
                  datarow.id,
                  datarow.externalId,
                  datarow.name,
                ),
              );
            })
            .fail(function (error, msg, d) {});
        },
        cellsrenderer: function () {
          return "Charge Codes";
        },
      },
      {
        text: "",
        width: 150,
        columnType: "button",
        sortable: false,
        filterable: false,
        pinned: true,
        buttonclick: function (row) {
          const datarow = $("#jqxAgencies").jqxGrid("getrowdata", row);

          agencyExternalMappingsWindow(
            new AgencyExternalMappingsViewModel({
              agencyId: datarow.id,
              agency: datarow.externalId,
              onChange: () => {
                //$("#jqxExternalCodes").jqxGrid('updatebounddata', 'data')
              },
            }),
          );
        },
        cellsrenderer: function () {
          return "External Mappings";
        },
      },
      { text: "Agency Code", dataField: "externalId", width: 120 },
      { text: "Agency Name", dataField: "name" },
      { text: "Agency Percent", dataField: "agencyPercent", width: 180 },
    ],
  });
};

const loadExternalCodes = function (
  parentWindow,
  externalMappingsWindow,
  userSavedFilters,
) {
  const $grid = $("#jqxExternalCodes");

  const source = {
    url: "AccessorialRestriction/GetTPChargeCodes",
    datatype: "json",
    data: {
      agencyId: userProfile.currentAgencyId(),
    },
    filter: (items) => {
      $grid.jqxGrid("updatebounddata", "filter");
    },
    sort: (column, sortOrder) => {
      $grid.jqxGrid("updatebounddata", "sort");
    },
    formatdata: (data) => {
      const filterinfo = $grid.jqxGrid("getfilterinformation");
      data = gridStateUtils.formatGridFilters(filterinfo, data);

      const payload = {
        take: data.pagesize,
        pagenum: data.pagenum,
        sortBy: data.sortDataField ?? "",
        ascending: data.sortOrder == "asc",
        thirdPartyCode: data.thirdPartyCode,
        thirdParty: data.thirdParty,
      };

      return payload;
    },
    loadServerData: async (serverdata, source, callback) => {
      try {
        const result = await apiDataAsync(source.url, "GET", serverdata);

        const records = (result.records ?? []).map((x) => {
          const assignments = x.assignments ?? [];
          return {
            thirdPartyCode: x.thirdPartyCode,
            thirdParty: x.thirdParty,
            totalMappings: `${assignments.length} Mappings`,
            assignments: assignments ?? [],
          };
        });

        callback({ records, totalrecords: result.totalRecords });
      } catch (err) {}
    },
    datafields: [
      { name: "thirdPartyCode", type: "string" },
      { name: "thirdParty", type: "string" },

      // These are mapped in the UI
      { name: "totalMappings", type: "string" },
      { name: "assignments", type: "array" },
    ],
  };

  var dataAdapter = dataModel.getDataAdapter(source);

  $grid.jqxGrid({
    width: "100%",
    source: dataAdapter,
    selectionmode: "single",
    height: 300,
    sortable: true,
    pageable: true,
    virtualmode: true,
    compact: true,
    pagesize: 10,
    filterable: true,
    showfilterrow: true,
    autoheight: false,
    columnsresize: false,
    columnsreorder: false,
    columnsmenu: false,
    showtoolbar: true,
    rowdetails: true,
    initrowdetails: (index, parent, grid, datarecord) => {
      const $container = $(parent).find(".mapping-details");
      const mappings = datarecord.assignments ?? [];

      const rowHeight = 30;
      const basePadding = 30;
      const calcHeight = mappings.length * rowHeight;

      //$grid.jqxGrid({rowdetailstemplate: { rowdetailsheight: calcHeight }});

      const mappingTableId = "mappingTable_" + index;
      const $mappingTable = $("<div>", { id: mappingTableId }).appendTo(
        $container,
      );

      const innerSource = {
        datatype: "array",
        datafields: [
          { name: "agencies", type: "string" },
          { name: "chargeCode", type: "string" },
        ],
        localdata: mappings.map((x) => {
          return {
            agencies: x.agencies.join(", "),
            chargeCode: x.chargeCode,
          };
        }),
      };

      const da = new $.jqx.dataAdapter(innerSource);
      $mappingTable.jqxGrid({
        width: "97%",
        source: da,
        autoheight: true,
        compact: true,
        columns: [
          {
            text: "Charge Code",
            dataField: "chargeCode",
            width: 250,
            cellsrenderer: (
              row,
              columnfield,
              value,
              defaulthtml,
              columnproperties,
            ) => {
              const $html = $(defaulthtml);
              const match = mappings.find((x) => x.chargeCode == value);

              if (match && match.chargeCodeDescription) {
                $html.html(
                  `${match.chargeCode} - ${match.chargeCodeDescription}`,
                );
              }

              return $html[0].outerHTML;
            },
          },
          { text: "Agencies", dataField: "agencies" },
        ],
      });
    },
    rowdetailstemplate: {
      rowdetails: "<div class='mapping-details' style='margin: 0px;'></div>",
      rowdetailsheight: 100,
      rowdetailshidden: true,
    },
    rendertoolbar: (toolbar) => {
      let vm1 = new gridState.viewModel();

      const $toolbar = $(toolbar);
      const $container = $("<div>");
      $toolbar.append($container);
      vm1.initializeDefaultToolbar($container);

      const $button = $("<button>", {
        class: "btn btn-ge-grey",
        id: "btnAddMapping",
        text: "Add Mapping",
        style:
          "padding: 3px 8px; font-size: 12px; margin-top: 2px; border: 1px solid #ccc;",
      }).appendTo($container);

      $button.on("click", function () {
        externalMappingsWindow(new ExternalMappingsViewModel());
      });
    },
    rendergridrows: function (obj) {
      return obj.data;
    },
    ready: function () {},
    columns: [
      { text: "Third Party Code", dataField: "thirdPartyCode" },
      {
        text: "Assignments",
        dataField: "totalMappings",
        width: 120,
        filterable: false,
        sortable: false,
      },
      {
        text: "External System",
        dataField: "thirdParty",
        width: 200,
        filtertype: "list",
        filteritems: ["Mastery"],
      },
      {
        text: "",
        width: 100,
        columnType: "button",
        sortable: false,
        filterable: false,
        buttonclick: function (row) {
          // var datarow = $("#jqxAgencies").jqxGrid('getrowdata', row);
          // dataModel.ajaxRequest("AccessorialRestriction/GetAgencyDetails/" + datarow.id, "GET")
          // .done(function (data, status, xhr) {
          //     self.agencyDetailsWindow(new agencyDetailsViewModel(data, datarow.id, datarow.externalId, datarow.name));
          // })
          // .fail(function (error, msg, d) {
          // });
        },
        cellsrenderer: function () {
          return "Assign";
        },
      },
    ],
  });
};

var viewModel = function (params) {
  var self = this;
  self.chargeCodeDetailsWindow = ko.observable();
  self.agencyDetailsWindow = ko.observable();
  self.externalMappingsWindow = ko.observable();
  self.agencyExternalMappingsWindow = ko.observable();

  self.loadUserSavedFilters = async (gridName) => {
    let state = {};

    let filters = await gridStateUtils
      .getUserGridFiltersAsync(gridName)
      .catch((err) =>
        console.error("Failed to retrieve jqxChargeCodes user filters."),
      );

    if (isEmpty(filters) == false) {
      let gs = JSON.parse(filters);
      state = gs.grid;
    }

    return Promise.resolve(state);
  };

  self
    .loadUserSavedFilters("jqxChargeCodes")
    .then((userSavedFilters) =>
      loadChargeCodes(self.chargeCodeDetailsWindow, userSavedFilters),
    );
  self
    .loadUserSavedFilters("jqxAgencies")
    .then((userSavedFilters) =>
      loadAgencies(
        self.agencyDetailsWindow,
        self.agencyExternalMappingsWindow,
        userSavedFilters,
      ),
    );
  //self.loadUserSavedFilters("jqxExternalMappings").then((userSavedFilters) => loadExternalCodes(self, self.externalMappingsWindow, userSavedFilters));
};

export default { viewModel: viewModel, template: template };
